import { render, staticRenderFns } from "./UnitMembers.vue?vue&type=template&id=80f25f40&scoped=true"
import script from "./UnitMembers.vue?vue&type=script&lang=js"
export * from "./UnitMembers.vue?vue&type=script&lang=js"
import style0 from "./UnitMembers.vue?vue&type=style&index=0&id=80f25f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f25f40",
  null
  
)

export default component.exports